class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;
    this.desktopMedia = window.matchMedia('(min-width: 990px)');

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.summary.addEventListener('click', this.onSummaryClick);

    this.bindHoverListeners();
    if (typeof this.desktopMedia.addEventListener === 'function') {
      this.desktopMedia.addEventListener('change', this.bindHoverListeners.bind(this));
    } else if (typeof this.desktopMedia.addListener === 'function') {
      this.desktopMedia.addListener(this.bindHoverListeners.bind(this));
    }
  }

  bindHoverListeners() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);

    // Desktop: open megamenu / dropdowns on hover
    if (this.desktopMedia.matches) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }
  }

  /**
   * Desktop: click parent label (SHOP, etc.) navigates to its menu link URL.
   * Hover already opens the panel — click should not only toggle <details>.
   * Hover-only parents (BY INGREDIENT): never navigate. A mouse click keeps
   * the hovered panel open; keyboard (event.detail === 0) still toggles.
   * Mobile: keep native toggle (no navigation hijack).
   */
  onSummaryClick(event) {
    if (!this.desktopMedia.matches) return;

    if (this.summary.dataset.hoverOnly === 'true') {
      if (event.detail > 0) {
        event.preventDefault();
        this.mainDetailsToggle.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const href = this.summary.dataset.href;
    if (!href || href === '#' || href === 'javascript:void(0)') return;

    event.preventDefault();
    window.location.href = href;
  }

  onMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    // Close any other open top-level menus
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onMouseLeave() {
    // Small delay so the pointer can move into the open panel without flicker
    this.closeTimeout = setTimeout(() => {
      this.close();
      this.onToggle();
      this.closeTimeout = null;
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
